import { NgModule } from '@angular/core';

import { FeesDetailsComponent } from './fees-details.modal.component';
import { CertemyCommonModule } from 'common/certemy-common.module';
import { FeesInitialScreenComponent } from './initial/fees-initial-screen.component';
import { FeesPaymentScreenComponent } from './payment/fees-payment-screen.component';
import { FeesFileUploadScreenComponent } from './file-upload/fees-file-upload-screen.component';
import { StepOnBehalfListModule } from 'features/professional-step/shared/on-behalf-list/step-on-behalf-list.module';
import { DisplayHtmlModule, FileUploadModule, RadioGroupModule, TextInputModule } from '@certemy/ui-components';
import { ConfirmInfoModule } from 'components/upload-confirm/confirm-info.module';
import { InlineErrorModule } from 'components/errors/inline-error.module';
import { FeesThirdPartyScreenComponent } from './third-party-payment/fees-third-party-screen.component';
import { VoucherConfirmScreenComponent } from './voucher-confirm/voucher-confirm-screen.component';
import { ResetConfirmModule } from '../reset-confirm-content/reset-confirm-content.module';
import { FeeFormProfessionalModule } from 'components/organization-certification/step/fee/fee-form-professional/fee-form-professional.module';
import { MessageBlockModule } from 'components/message-block/message-block.module';
import { PaymentFormModule } from 'features/payment-form';

@NgModule({
  imports: [
    CertemyCommonModule,
    StepOnBehalfListModule,
    FileUploadModule,
    PaymentFormModule,
    ConfirmInfoModule,
    InlineErrorModule,
    DisplayHtmlModule,
    ResetConfirmModule,
    FeeFormProfessionalModule,
    MessageBlockModule,
    RadioGroupModule,
    TextInputModule,
  ],
  exports: [FeesDetailsComponent],
  declarations: [
    FeesDetailsComponent,
    FeesInitialScreenComponent,
    FeesPaymentScreenComponent,
    FeesFileUploadScreenComponent,
    FeesThirdPartyScreenComponent,
    VoucherConfirmScreenComponent,
  ],
})
export class FeesDetailsModalModule {}
